import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import {
  Plan,
  PlanResourcePayload,
  SoulPlanModel,
} from "../models/Plan/PlanModel";

export class PlanApi extends BaseApi {
  private static instance: PlanApi;

  public static get(): PlanApi {
    if (!this.instance) {
      this.instance = new PlanApi();
    }
    return this.instance;
  }

  public allPlans = BaseApi.createEndpoint<Plan[], null>(
    HttpMethodEnum.GET,
    "/plan/all"
  );

  public pushNewResource = BaseApi.createEndpoint<null, PlanResourcePayload>(
    HttpMethodEnum.POST,
    "/plan/resource"
  );

  public deleteResource = BaseApi.createEndpoint<null, PlanResourcePayload>(
    HttpMethodEnum.DELETE,
    "/plan/resource"
  );

  public getPlan = BaseApi.createEndpoint<
    { soulPlan: SoulPlanModel; plans: Plan[] },
    null
  >(HttpMethodEnum.GET, "/plan/");
}

export const planApi = PlanApi.get();
